// @flow

// Type fully described at
// https://github.homeawaycorp.com/experimentation-platform/node-abacus/blob/master/API.md#EvaluationData
export type AbacusEvaluationData = {
    bucket: {bucketConfig: ?string},
    experimentKey: {experimentId: number, experimentName: string},
    value: number
};

export type State = {
    [string]: AbacusEvaluationData
};

const initialState = {};

// abacus state is set up via the initialState passed to createStore, so we don't need any actions
const identity = (state: State = initialState) => state;

export default identity;
